/**
 * @flow
 * @relayHash df1a9c834992122ea8ccfd4f9136025f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SocialAuthInput = {|
  provider: string,
  accessToken: string,
  clientMutationId?: ?string,
|};
export type SocialAuthMutationVariables = {|
  input: SocialAuthInput
|};
export type SocialAuthMutationResponse = {|
  +socialAuth: ?{|
    +token: ?string,
    +refreshToken: ?string,
    +userType: ?string,
    +clientMutationId: ?string,
  |}
|};
export type SocialAuthMutation = {|
  variables: SocialAuthMutationVariables,
  response: SocialAuthMutationResponse,
|};
*/


/*
mutation SocialAuthMutation(
  $input: SocialAuthInput!
) {
  socialAuth(input: $input) {
    token
    refreshToken
    userType
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SocialAuthInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "socialAuth",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SocialAuthPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "token",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "refreshToken",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "userType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SocialAuthMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SocialAuthMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SocialAuthMutation",
    "id": null,
    "text": "mutation SocialAuthMutation(\n  $input: SocialAuthInput!\n) {\n  socialAuth(input: $input) {\n    token\n    refreshToken\n    userType\n    clientMutationId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '64d5d49f4a7bf53f9922cdd32b4b88ac';
module.exports = node;
